import { ref } from 'vue'

const currency = ref('NOK')

export function useCurrency() {
    return {
        currency
    }
}